/**
 * The internal note of the summary card. It is page-level (FR7a): a mixed order writes one note that
 * every RMA the session creates carries, so it lives on the session store.
 */
import { observer } from 'mobx-react';
import React from 'react';
import { Textarea, TEXTAREA_VARIANTS } from '../../../components/inputs/textarea/textarea';
import useDashboardTranslation from '../../../dashboard-translation/hooks/dashboard-translation-hook';
import CreateRmaSessionStore from '../stores/create-rma-session-store';

interface IProps {
	sessionStore: CreateRmaSessionStore;
}

const SummaryNote: React.FC<IProps> = observer(({ sessionStore }) => {

	const { getTranslation } = useDashboardTranslation();
	const pageScope = 'dashboard-create-rma';

	return (
		<div className={'displayNote'}>
			<Textarea value={sessionStore.note}
			          onChange={sessionStore.setNote}
			          variant={TEXTAREA_VARIANTS.DEFAULT}
			          placeholder={getTranslation('NOTE_PLACEHOLDER', pageScope)}
			/>
		</div>
	);
});

export default SummaryNote;
